import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";

import withTranslations from "../../../../../hocs/withTranslations";
import { BodyRegular } from "../../../common/Typography";
import CookieConsentOptionRow from "./CookieConsentOptionRow";

const CookieConsentSection = ({
  section,
  consentOptions,
  toggleConsentOption,
  translate
}) => (
  <div>
    <div className="flex align-center justify-between gap-3">
      <BodyRegular tag="span" weight={700} className="text-base">
        {translate(section.titleKey)}
      </BodyRegular>
      {section.alwaysActive ? (
        <BodyRegular tag="span" className="italic opacity-70">
          {translate("cookie_always_active")}
        </BodyRegular>
      ) : null}
    </div>
    {section.items?.length ? (
      <div className="flex flex-col gap-3 mt-3">
        {section.items.map(item => (
          <CookieConsentOptionRow
            key={item.key}
            consentKey={item.key}
            consentOptions={consentOptions}
            label={translate(item.labelKey)}
            toggleConsentOption={toggleConsentOption}
          />
        ))}
      </div>
    ) : null}
  </div>
);

CookieConsentSection.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
    titleKey: PropTypes.string.isRequired,
    alwaysActive: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        labelKey: PropTypes.string.isRequired
      })
    )
  }).isRequired,
  consentOptions: PropTypes.objectOf(PropTypes.bool).isRequired,
  toggleConsentOption: PropTypes.func.isRequired
};

export default compose(withTranslations)(CookieConsentSection);
